exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-chip-group[data-v-51f9d44f] .v-slide-group__content {\n  justify-content: center;\n}\n.darken-50[data-v-51f9d44f] {\n  background: rgba(0, 0, 0, 0.5);\n}\n.darken-60[data-v-51f9d44f] {\n  background: rgba(0, 0, 0, 0.6);\n}", ""]);

// exports
